package ru.it_mozaika.sender.js.application

import mui.material.CssBaseline
import react.FC
import react.PropsWithChildren
import ru.it_mozaika.components.SnackbarProvider
import ru.it_mozaika.sender.js.application.context.*

val Layout = FC<PropsWithChildren> { props ->
    BackdropProvider {
        SnackbarProvider {
            RequestResultProvider {
                UserProvider {
                    StoreProvider{
                            CssBaseline()
                            +props.children
                    }
                }
            }
        }
    }
}
